export default __webpack_public_path__ + "static/media/social-google.a57081bd.svg";